export default [
  {
    symbol: '¼',
    entity: '&frac14;',
    name: 'Fraction One Quarter',
    css: '\\00BC',
  },
  {
    symbol: '½',
    entity: '&frac12;',
    name: 'Fraction One Half',
    css: '\\00BD',
  },
  {
    symbol: '¾',
    entity: '&frac34;',
    name: 'Fraction Three Quarters',
    css: '\\00BE',
  },
  {
    symbol: '⅓',
    entity: '&frac13;',
    name: 'Vulgar Fraction One Third',
    css: '\\2153',
  },
  {
    symbol: '⅔',
    entity: '&frac23;',
    name: 'Vulgar Fraction Two Thirds',
    css: '\\2154',
  },
  {
    symbol: '⅕',
    entity: '&frac15;',
    name: 'Vulgar Fraction One Fifth',
    css: '\\2155',
  },
  {
    symbol: '⅖',
    entity: '&frac25;',
    name: 'Vulgar Fraction Two Fifths',
    css: '\\2156',
  },
  {
    symbol: '⅗',
    entity: '&frac35;',
    name: 'Vulgar Fraction Three Fifths',
    css: '\\2157',
  },
  {
    symbol: '⅘',
    entity: '&frac45;',
    name: 'Vulgar Fraction Four Fifths',
    css: '\\2158',
  },
  {
    symbol: '⅙',
    entity: '&frac16;',
    name: 'Vulgar Fraction One Sixth',
    css: '\\2159',
  },
  {
    symbol: '⅚',
    entity: '&frac56;',
    name: 'Vulgar Fraction Five Sixths',
    css: '\\215A',
  },
  {
    symbol: '⅛',
    entity: '&frac18;',
    name: 'Vulgar Fraction One Eighth',
    css: '\\215B',
  },
  {
    symbol: '⅜',
    entity: '&frac38;',
    name: 'Vulgar Fraction Three Eighths',
    css: '\\215C',
  },
  {
    symbol: '⅝',
    entity: '&frac58;',
    name: 'Vulgar Fraction Five Eighths',
    css: '\\215D',
  },
  {
    symbol: '⅞',
    entity: '&frac78;',
    name: 'Vulgar Fraction Seven Eighths',
    css: '\\215E',
  },
];
